import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { ref, onValue } from "firebase/database";
import { db } from "../Firebase/firebase-config"; // adjust the path if needed
import "./BroadcastTicker.css";

const UserBroadcastTicker = () => {
    const [broadcasts, setBroadcasts] = useState([]);
    const auth = getAuth();
    const currentUserId = auth.currentUser?.uid || "";

    useEffect(() => {
        if (!currentUserId) return;

        const broadcastRef = ref(db, `broadcasts/${currentUserId}`);
        const unsubscribe = onValue(broadcastRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                const sentBroadcasts = Object.values(data)
                    .filter((item) => item.status === "sent")
                    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)); // latest first
                setBroadcasts(sentBroadcasts);
            } else {
                setBroadcasts([]);
            }
        });

        return () => unsubscribe();
    }, [currentUserId]);

    if (broadcasts.length === 0) {
        return null; // or show a default message
    }

    return (
        <div className="broadcast-ticker-wrapper">
            <div className="broadcast-ticker-track">
                {broadcasts.map((b, index) => (
                    <div key={index} className="broadcast-ticker-item">
                        <div key={index} className="broadcast-ticker-item">
                            <span>📢</span>&nbsp;
                            <strong>{b.heading}:</strong>&nbsp;
                            {b.message} {"  "}
                            <strong style={{color: 'blue'}}> {" "} validity : </strong> {b.validity}

                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default UserBroadcastTicker;
